import React from 'react';
import { RCIcon } from '../RCIcon/RCIcon';
import { ChevronRightIcon } from '../../icons/react';
import classNames from 'classnames';

export interface RCAutocompleteItemProps {
  /** Text to be displayed for the item. */
  title: string;

  /** Item id. Can be any string, but must be unique. */
  id: string;

  /** Optional type that can be referenced in onClick handler. */
  type?: string;

  /** Optional callback to be fired on item click / select. */
  onClick?: () => void;

  /** Optional style variants. */
  variant?: 'default' | 'link' | 'disabled' | 'parent';
}

export const RCAutocompleteItem = React.forwardRef<
  HTMLLIElement, RCAutocompleteItemProps
>(({
  title,
  id,
  variant = 'default',
  ...passthroughProps
}, ref) => {
  return (
    <li
      className={classNames(
        'rc-autocomplete-item',
        { 'rc-autocomplete-item--link': variant === 'link' },
      )}
      ref={ref}
      id={id}
      role="option"
      aria-selected="false"
      aria-disabled={variant === 'disabled'}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...passthroughProps}
    >
      {title}
      {variant === 'parent' &&
        <span className="rc-autocomplete-item__icon">
          <RCIcon svgComponent={ChevronRightIcon} />
        </span>
      }
    </li>
  );
});

RCAutocompleteItem.displayName = 'RCAutocompleteItem';
